export const TagColors = {
    72: "#00A6D2",
    76: "#6EB64D",
    75: "#A7737A",
    74: "#7283A7",
    73: "#BA6878",
    77: "#4DB6AC",
    78: "#F06292"
}
